const getTabsConfigManagement = () => ({
  tabs: [
    {
      label: 'Dashboard',
      route: 'SERVER_DASHBOARD',
    },
    {
      label: 'Statistiques',
      route: 'STATS',
    },
    {
      label: 'Remboursements',
      route: 'REFUNDS',
    },
    {
      label: 'Compatibilité des factions',
      route: 'FACTION_COMPATIBILITY',
    },
    {
      label: 'Véhicules',
      route: 'VEHICLES',
    },
    {
      label: 'Doubles comptes',
      route: 'DUPLICATE_ACCOUNTS',
    },
    {
      label: 'Ressources',
      route: 'GAME_RESOURCES',
    },
    {
      label: 'DarkChat',
      route: 'DARKCHAT',
    },
    {
      label: 'Tops',
      route: 'RANKING_MONEY',
    }
  ],
})

export default getTabsConfigManagement
